var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAgenda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400 64h-64V8C336 3.578 332.4 0 328 0S320 3.578 320 8V64H128V8C128 3.578 124.4 0 120 0S112 3.578 112 8V64h-64C21.5 64 0 85.5 0 112v352C0 490.5 21.5 512 48 512h352c26.5 0 48-21.5 48-48v-352C448 85.5 426.5 64 400 64zM432 464c0 17.64-14.36 32-32 32h-352c-17.64 0-32-14.36-32-32v-256h416V464zM432 192h-416V112c0-17.64 14.36-32 32-32h64V128c0 4.422 3.594 8 8 8S128 132.4 128 128V80h192V128c0 4.422 3.594 8 8 8S336 132.4 336 128V80h64c17.64 0 32 14.36 32 32V192zM134.2 448c.3887 0 .6777-.0518 1.07-.1318l50.52-10.07l3.133-1.678l122.9-122.9c10.94-10.93 10.94-28.66 .0039-39.6l-9.408-9.41c-10.93-10.93-28.66-10.94-39.6-.002l-122.9 122.9l-1.672 3.125l-10.07 50.52C127.3 444.9 130.6 448 134.2 448zM274.1 275.5c4.688-4.684 12.28-4.689 16.97 .002l9.408 9.41c4.676 4.676 4.702 12.26-.002 16.97l-17.65 17.64l-26.38-26.38L274.1 275.5zM153.3 396.3l91.86-91.86l26.38 26.38l-91.86 91.85l-32.96 6.592L153.3 396.3z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgenda);
export default __webpack_public_path__ + "static/media/agenda.dfa8dcf2.svg";
export { ForwardRef as ReactComponent };